import subscription from './subscription';
import { WSDATA } from '@/assets/js/common/constant';
class Socket {
  constructor(url, win) {
    this.url = url;
    this.ws = null;
    this.isConnect = false; //是否连接成功
    this.delayedws = 5000; //重连间隔
    this.reConnectTimer = null; //重连计时器
    this.heartTimer = null; //心跳计时器
    this.subList = []; //订阅列表 断线重连后需要重新订阅
    this.networkStatus(win);
    this.unnetworkStatus(win);
    if (this.url != '') {
      this.connection();
    }
  }
  //监控网络变化
  networkStatus(window) {
    let el = window.document.body;
    if (el.addEventListener) {
      window.addEventListener('online', this.online.bind(this), true);
      window.addEventListener('offline', this.offline.bind(this), true);
    } else if (el.attachEvent) {
      window.attachEvent('ononline', this.online.bind(this));
      window.attachEvent('onoffline', this.offline.bind(this));
    } else {
      window.ononline = this.online.bind(this);
      window.onoffline = this.offline.bind(this);
    }
  }
  //移除监控网络变化
  unnetworkStatus(window) {
    let el = window.document.body;
    if (el.removeEventListener) {
      window.removeEventListener('online', this.online.bind(this), true);
      window.removeEventListener('offline', this.offline.bind(this), true);
    } else if (el.detachEvent) {
      window.detachEvent('ononline', this.online.bind(this));
      window.detachEvent('onoffline', this.offline.bind(this));
    } else {
      window.ononline = null;
      window.onoffline = null;
    }
  }
  //网络断开
  offline() {
    console.log('%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%网络状态：断开了', new Date().toString());
    // subscription.getInstance().notify({ dataType: OFFLINE }); //断网了
    this.reConnection(false); //马上开启重连
  }
  //网络链接成功
  online() {
    console.log('%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%网络状态：连接成功', new Date().toString());
    // subscription.getInstance().notify({ dataType: ONLINE }); //连接成功
    this.reConnection(false); //马上开启重连
  }
  // 连接
  connection() {
    this.ws = new WebSocket(this.url);
    this.ws.onopen = () => {
      if (this.reConnectTimer) {
        clearTimeout(this.reConnectTimer);
        this.reConnectTimer = null;
      }
      console.log('>>>>>连接成功');
      this.isConnect = true;
      this.ws.pingT = new Date().getTime(); //连接成功 初始化ping和pong时间
      this.ws.pongT = new Date().getTime(); //连接成功 初始化ping和pong时间
      this.reSub(); //订阅所有topic
      this.check(); //开启心跳
    //   subscription.getInstance().notify({ dataType: ONLINE }); //连接成功
    };
    this.ws.onmessage = message => {
      // console.log('message:::', message);
      let _data =null;
      if(typeof message.data !=='string'){
        
        // var blob = new Blob(message.data,{type: 'text/html'});
        message.data.arrayBuffer().then(res=>{
          _data = JSON.parse(pako.inflateRaw(res, { to: 'string' }));
          if (_data&&_data.event && _data.event === 'pong') {
            this.onPong(_data.event);
            return null;
          }
          if (_data&&_data.channel) {
            if (!_data.data.result) {
              let _v = null,
                _isSame = true,
                _i = 0,
                _str = '';
              for (; _i < this.subList.length; _i++) {
                _isSame = true;
                _v = this.subList[_i];
                for (let pro in _v.params) {
                  if (_v.params[pro] != _data[pro]) {
                    _isSame = false;
                  }
                }
                if (_isSame == true) {
                  _str = JSON.stringify(_v);
                  this.ws.send(_str);
                  break;
                }
              }
            }
            return null;
          }
          subscription.getInstance().notify({ dataType: WSDATA }, _data); //连接成功
        })
        return null
        // _data = JSON.parse(blob);
      }else{
        _data = JSON.parse(message.data);
      }
  
      if (_data&&_data.event && _data.event === 'pong') {
          this.onPong(_data.event);
          return null;
      }
      if (_data&&_data.channel) {
          if (!_data.data.result) {
            let _v = null,
              _isSame = true,
              _i = 0,
              _str = '';
            for (; _i < this.subList.length; _i++) {
              _isSame = true;
              _v = this.subList[_i];
              for (let pro in _v.params) {
                if (_v.params[pro] != _data[pro]) {
                  _isSame = false;
                }
              }
              if (_isSame == true) {
                _str = JSON.stringify(_v);
                this.ws.send(_str);
                break;
              }
            }
          }
          return null;
      }
      subscription.getInstance().notify({ dataType: 'WSDATA' }, _data); //连接成功
    };
    this.ws.onerror = () => {
      console.log('=====>onerror 开始重连');
      this.reConnection(true);
    };
    this.ws.onclose = error => {
      console.log('=====>onclose 开始重连');
      this.reConnection(true);
    };
  }
  // 重连
  reConnection(delayed = false) {
    this.isConnect = false;
    if (delayed) {
      console.log('》》》》》》》》》》延时重连《《《《《《《《《');
      if (this.reConnectTimer == null) {
        this.close(); //关闭ws
        this.destoryws(); //销毁ws
        console.log('>>>>>重连：延时重连 计时开始---', new Date().getTime());
        this.reConnectTimer = setTimeout(() => {
          if (this.reConnectTimer) {
            clearTimeout(this.reConnectTimer);
            this.reConnectTimer = null;
          }
          console.log('>>>>>重连：延时结束 开始连接===', new Date().getTime());
          this.connection();
        }, this.delayedws);
      } else {
        console.log('正在重连中。。。');
      }
    } else {
      //否则立刻重连
      console.log('>>>>>重连：立即重连', new Date().toString());
      this.close(); //关闭ws
      this.destoryws(); //销毁ws
      if (this.reConnectTimer) {
        clearTimeout(this.reConnectTimer);
        this.reConnectTimer = null;
      }
      this.connection();
    }
  }

  // 心跳检查
  check() {
    let pingT = this.ws.pingT,
      pongT = this.ws.pongT;
    if (Math.abs(pingT - pongT) > 6000) {
      // 2000ms发送一次ping 如果服务器能在6000ms内回馈数据则认为服务器正常 否则认为延时
      // console.log(key, "发送心跳--服务器已经超时回复", Math.abs(pingT - pongT));
      if (Math.abs(pingT - pongT) > 12000) {
        console.log('>>>>>服务器超时回复严重：开始重连', new Date().toString());
        this.reConnection(true);
        return;
      }
    } else {
      //心跳正常 清空提示
    }

    try {
      //更新ping时间
      this.ws.pingT = new Date().getTime();
      //发送ping
      try {
        this.ws.send("{'event':'ping'}");
      } catch (error) {
        console.log('发送心跳', error);
      }
      //循环心跳
      this.heartTimer = setTimeout(() => {
        this.check();
      }, 2000);
    } catch (error) {
      //立即重连
      console.log('>>>>>发送ping失败:重连', new Date().toString());
      this.reConnection(true);
    }
  }

  //重新订阅
  reSub() {
    let value = {};
    for (let i = 0; i < this.subList.length; i++) {
      value = this.subList[i];
      try {
        this.ws.send(JSON.stringify(value));
      } catch (error) {
        console.log('订阅数据', value, error);
      }
    }
  }

  //订阅
  sub(value) {
    let isSame = false;
    // console.log('订阅内容：', value);
    for (let i = 0; i < this.subList.length; i++) {
      if (this.isEqual(this.subList[i], value)) {
        isSame = true;
        break;
      }
    }
    if (!isSame) {
      // console.log('没有一样的订阅，放入订阅列表');
      this.subList.push(value);
    } else {
      // console.log('现有的订阅');
      // console.log(this.subList);
    }
    try {
      if (this.isConnect) {
        // console.log('发送订阅');
        this.ws.send(JSON.stringify(value));
      }
    } catch (error) {
      console.log('订阅数据', value, error);
    }
  }

  //取消订阅
  unsub(value) {
    let _value = JSON.parse(JSON.stringify(value));
    _value.event = 'subscribe';
    // console.log('移除订阅内容：', _value);
    let i = 0;
    for (; i < this.subList.length; i++) {
      if (this.isEqual(this.subList[i], _value)) {
        // console.log('有相同topic,移除订阅：', this.subList[i]);
        this.subList.splice(i, 1);
        break;
      }
    }
    // if (i == this.subList.length) {
    // console.log('现有的订阅');
    // console.log(this.subList);
    // }
    try {
      if (this.isConnect) {
        // console.log('移除订阅');
        this.ws.send(JSON.stringify(value));
      }
    } catch (error) {
      console.log('取消订阅数据', value, error);
    }
  }

  //关闭
  close() {
    if (this.heartTimer) {
      clearTimeout(this.heartTimer); //停止心跳
      this.heartTimer = null;
    }
    try {
      //关闭
      if (this.ws) {
        this.ws.close();
      }
    } catch (error) {
      console.log('关闭报错', error);
    }
  }

  //销毁
  destoryws() {
    if (this.ws) {
      this.ws.onopen = null;
      this.ws.onmessage = null;
      this.ws.onerror = null;
      this.ws.onclose = null;
      this.ws = null;
    }
  }

  // 接收ping返回信息
  onPong() {
    this.ws.pongT = new Date().getTime();
  }

  //销毁方法
  destory() {
    //关闭ws
    this.close();
    //销毁ws
    this.destoryws();
    //停止ws延时重连
    if (this.reConnectTimer) {
      clearTimeout(this.reConnectTimer);
      this.reConnectTimer = null;
    }
  }

  //比较两个object是否相同
  isEqual(obj1, obj2) {
    if (obj1 instanceof Object && obj2 instanceof Object) {
      if (Object.keys(obj1).length != Object.keys(obj2).length) {
        return false;
      }
      for (let attr in obj1) {
        if (obj1[attr] instanceof Object && obj2[attr] instanceof Object) {
          return this.isEqual(obj1[attr], obj2[attr]);
        } else if (obj1[attr] != obj2[attr] && attr != 'since') {
          //since 不做判断 since是时间戳
          return false;
        }
      }
      return true;
    } else {
      return obj1 == obj2;
    }
  }
}

let SocketInstance = null;

export default function (url, win) {
  if (!SocketInstance) {
    SocketInstance = new Socket(url, win);
  }
  return SocketInstance;
}



// WEBPACK FOOTER //
// ./src/assets/socket/socketBase.js